import { render, staticRenderFns } from "./guider_grade.vue?vue&type=template&id=dc6f21ca&scoped=true"
import script from "./guider_grade.vue?vue&type=script&lang=js"
export * from "./guider_grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6f21ca",
  null
  
)

export default component.exports